<template>
  <div>
    <Headersys />
    <div class="content">
      <!-- <div> -->
      <div v-if="current == 1">
        <div class="face-idcard-body">
          <div class="idcard-content">
            <div class="idcard-top-title">证件信息</div>
            <div class="idcard-card-avatar">
              <div>
                <div style="height: 10rem"></div>
                <div class="idcard-box">
                  <div class="idcard-title">姓名</div>
                  <div>:</div>
                  <div class="idcard-userinfo">
                    {{ idcardInfo.name }}
                  </div>
                </div>
                <div class="idcard-box">
                  <div class="idcard-title">性别</div>
                  <div>:</div>
                  <div class="idcard-userinfo">
                    {{ idcardInfo.sex }}
                  </div>
                </div>
                <div class="idcard-box">
                  <div class="idcard-title">民族</div>
                  <div>:</div>
                  <div class="idcard-userinfo">
                    {{ idcardInfo.nation }}
                  </div>
                </div>
                <div class="idcard-box">
                  <div class="idcard-title">出生</div>
                  <div>:</div>
                  <div class="idcard-userinfo">
                    {{ idcardInfo.birthday }}
                  </div>
                </div>
              </div>
              <img class="user-idcard-avatar" :src="idcardInfo.avatar" alt="" />
            </div>
            <div class="user-info-box">
              <div class="user-info-title">住址</div>
              <div>:</div>
              <div class="userinfo-info">
                {{ idcardInfo.address }}
              </div>
            </div>
            <div class="user-info-box">
              <div class="user-info-title">证件号</div>
              <div>:</div>
              <div class="userinfo-info">
                {{ idcardInfo.cerno }}
              </div>
            </div>
            <div class="user-info-box">
              <div class="user-info-title">有效期</div>
              <div>:</div>
              <div class="userinfo-info">
                {{ idcardInfo.date }}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="firm-box" v-else-if="current == 2">
        <div
          class="firm-card"
          v-for="item in firmList"
          :key="item.entname"
          @click="ceratImages(item)"
        >
          <div>企业名称:{{ item.entname }}</div>
          <div>法人:{{ item.lerep }}</div>
          <div>统一社会信用代码:{{ item.uniscid }}</div>
        </div>
      </div>
      <div id="loadDom" v-else>
        <yyzzPreview :firmData="firmData" />
      </div>
      <Back :print="print" @toPrintEve="userClice" />
      <!-- </div> -->
    </div>
    <div class="admin-tips">
      1.本终端暂时只支持打印2024年11月1日之后新办（换证）的营业执照
      <div>
        2.请将打印的营业执照与当前展示营业执照信息进行比对,如信息不一致,请联系技术人员
      </div>
      <div>3.技术支持电话:13176708822、17515423293</div>
    </div>
  </div>
</template>
<script>
import { Loading } from "element-ui";
import lodop from "@/assets/js/lodop";
// import QRCode from "qrcode";
import yyzzPreview from "../../components/yyzzPreview.vue";
export default {
  components: { yyzzPreview },
  name: "",
  data() {
    return {
      //
      current: 1,
      loadingInstance: null,
      waitTime: 280,
      watiTimer: null,
      form: {},
      print: "1",
      firmData: {}, //展示用企业信息
      fmac: "",
      phone: "",
      name: "",
      idCard: "",
      debounceTimer: null,
      idcardInfo: {}, //刷身份证显示的信息
      wsUri: "ws://127.0.0.1:24012", //刷身份证ws
      cerno: "", //企业查询使用身份证
      firmList: [], //企业信息
    };
  },
  created() {
    //链接身份证读卡设备
    this.websopen();
    this.$fun.getMAC((mac) => {
      this.fmac = mac;
      // var userInfo = JSON.parse(localStorage.getItem('USERINFO'))
    });
    var userInfo = this.$store.state.suerInfo;
    this.name = userInfo.name;
    this.phone = userInfo.tel;
    this.idCard = userInfo.cerno;
  },
  mounted() {
    //开启倒计时
    this.timeDown();
  },
  destroyed() {
    console.log("页面销毁");
    clearTimeout(this.watiTimer);
  },
  methods: {
    userClice() {
      this.debounce(this.checkPrint, 250);
    },
    // 防抖函数
    debounce(fn, wait) {
      if (this.debounceTimer !== null) {
        clearTimeout(this.debounceTimer);
      }
      this.debounceTimer = setTimeout(fn, wait);
    },
    // 生成企业码
    // 生成营业执照图片
    ceratImages(data) {
      console.log(data);
      if (data.enttype >= 1100 && data.enttype < 1200) {
        data.enttype = "1";
      } else if (data.enttype == "9999") {
        data.enttype = "8";
      } else {
        this.$alert("该企业类型请选择扫码方式办理业务", "提示", {
          confirmButtonText: "确定",
        });
        return;
      }
      data.estdate = this.$fun.getTime(data.estdate, "年");
      data = Object.assign(data, this.$fun.disassembleTime(data.apprdate));
      if (data.regcap) {
        var str = data.regcap.toString();
        var regcap = str.replace(/[^0-9]/gi, "") * 10000;
        data.regcap = this.$fun.dealBigMoney(regcap);
      }
      // if (data.enttype != '8') {
      //   var opfrom = data.opfrom
      //   var opto = data.opto
      //   if (opto == '99991231') {
      //     data.jyqx = opfrom.slice(0, 4) + " 年 " + opfrom.slice(4, 6) + " 月 " + opfrom.slice(6, 8) + " 日 至  年  月  日"
      //   } else {
      //     data.jyqx = opfrom.slice(0, 4) + " 年 " + opfrom.slice(4, 6) + " 月 " + opfrom.slice(6, 8) + " 日 至 " + opfrom.slice(0, 4) + " 年 " + opto.slice(4, 6) + " 月 " + opto.slice(6, 8) + " 日"
      //   }
      // }
      this.firmData = data;
      this.form = data;
      this.current = 3;
      this.print = "2";
    },
    // 倒计时
    timeDown() {
      this.watiTimer = setInterval(() => {
        if (this.waitTime > 1) {
          this.waitTime--;
        } else {
          this.waitTime = 280;
          clearInterval(this.watiTimer);
          this.$router.replace("/");
        }
      }, 1000);
    },
    // 查询是否已打印
    checkPrint() {
      var obj = this.form;
      // obj.apprdate 判断
      // 1722355200000
      if (obj.apprdate < 1730390400000) {
        this.$alert(
          "本终端暂时只支持打印2024年11月1日之后新办（换证）的营业执照",
          "温馨提示",
          {
            confirmButtonText: "确定",
            lockScroll: false,
          }
        );
        return;
      }
      // 获取当前时间
      var now = new Date();
      // 设置20天前的时间
      now.setDate(now.getDate() - 20);
      // 获取两天前的时间戳
      var twoDaysAgoTimestamp = now.getTime();
      if (obj.apprdate < twoDaysAgoTimestamp) {
        this.$alert(
          "此方式暂时只支持打印20天内新办（换证）的营业执照",
          "温馨提示",
          {
            confirmButtonText: "确定",
            lockScroll: false,
          }
        );
        return;
      }
      this.$rqt.print_getOne(obj.uniscid).then((res) => {
        // console.log('打印查询', res);
        // this.creatQrCodeUrl(obj)
        // return
        if (!res.data) {
          this.creatQrCodeUrl(obj);
        } else {
          this.$alert("营业执照已打印，请勿重复打印！", "温馨提示", {
            confirmButtonText: "确定",
            lockScroll: false,
          });
        }
      });
    },
    // 打印营业执照
    printZB(data, url) {
      console.log("经营范围长度", data.opscope.length);
      if (data.opscope.length > 700) {
        this.$alert(
          "您的营业执照经营范围内容过长暂不支持终端打印,请到奎文区政务服中心窗口打印",
          "提示",
          {
            confirmButtonText: "确定",
            lockScroll: false,
          }
        );
        return;
      }
      this.savePrintRecord(data.uniscid, data.entname);
      this.loadingInstance = Loading.service({
        fullscreen: true,
        text: "正在打印...",
        target: document.querySelector("#loadDom"),
      });
      setTimeout(() => {
        this.loadingInstance.close();
      }, 20000);
      if (data.enttype == "1") {
        // 内资公司
        lodop.YYZZZB1(data, url);
        lodop.YYZZFB1(data, url);
        return;
      }
      if (data.enttype == "3") {
        // 内资非公司企业
        lodop.YYZZZB2(data, url);
        lodop.YYZZFB2(data, url);
        return;
      }
      if (data.enttype == "4") {
        // 合伙企业
        lodop.YYZZZB4(data, url);
        lodop.YYZZFB4(data, url);
        return;
      }
      if (data.enttype == "6") {
        // 农民专业合作社法人
        lodop.YYZZZB6(data, url);
        lodop.YYZZFB6(data, url);
        return;
      }
      if (data.enttype == "7") {
        // 个人独资企业
        lodop.YYZZZB7(data, url);
        lodop.YYZZFB7(data, url);
        return;
      }
      if (data.enttype == "8") {
        // 个体工商户
        lodop.YYZZZB8(data, url);
        lodop.YYZZFB8(data, url);
        return;
      }
      this.$alert("外资公司请到窗口办理业务", "提示", {
        confirmButtonText: "确定",
      });
      // if (data.enttype == '15') {
      //   // 农民专业合作社分支机构
      //   lodop.YYZZZB15(data, url)
      //   lodop.YYZZFB15(data, url)
      //   return
      // }
      // lodop.YYZZZB11(data, url)
      // lodop.YYZZFB11(data, url)
    },
    savePrintRecord(uniscid, entName) {
      this.$rqt.print_save({
        uniscid,
        type: "打印营业执照",
        entName,
        fmac: this.fmac,
        name: this.name,
        phone: this.phone,
        idCard: this.idCard,
      });
    },
    // 生成二维码路径
    creatQrCodeUrl(data) {
      this.$rqt.print_getEntCode(data.uniscid, data.entname).then((res) => {
        console.log(res);
        var data = JSON.parse(res.msg);
        if (data.message_content.qrimage) {
          var codeUrl = "data:image/jpg;base64," + data.message_content.qrimage;
          this.printZB(this.firmData, codeUrl);
        } else {
          this.$alert(data.message_header.errorInfo, "提示", {
            confirmButtonText: "确定",
            lockScroll: false,
          });
        }
      });
    },
    goBack() {
      this.$router.back();
    },
    websopen() {
      this.webSkt = new WebSocket(this.wsUri);
      this.webSkt.onopen = (evt) => {
        this.doSend(
          '{"module":"idcard","msgid":"123456789","function":"autoreadcard","parameter":{"dev":"1","repeat":"1","readtype":"1"}}'
        );
      };
      this.webSkt.onmessage = (evt) => {
        this.onMessage(evt);
      };
      this.webSkt.onerror = (evt) => {
        console.log("身份证错误", evt);
      };
    },
    doSend(message) {
      this.webSkt.send(message);
    },
    onMessage(evt) {
      var jsondata = JSON.parse(evt.data);
      console.log("返回信息", jsondata);
      if (jsondata.event == "onreadcard") {
        var data = jsondata.Certificate;
        this.webSkt.close();
        this.cerno = data.IDNumber;
        this.idcardInfo = {
          name: data.Name,
          sex: data.Sex,
          nation: data.Nation,
          birthday: data.Birthday,
          avatar: "data:image/bmp;base64," + data.Base64Photo,
          cerno:
            data.IDNumber.substring(0, 6) +
            "*".repeat(8) +
            data.IDNumber.substring(14),
          address: data.Address,
          date: data.IssuedData + "至" + data.ValidDate,
        };
        // "371721200304231379" 370702198205031064
        this.$rqt.sms_getInfoList(this.$doSm4(this.cerno)).then((res) => {
          if (res.msg) {
            // var data = res
            this.$alert("未查询到企业信息", "提示", {
              confirmButtonText: "确定",
              callback: (action) => {
                this.goBack();
              },
            });
          } else {
            var data = JSON.parse(this.$dptSm4(res));
            var list = [];
            data.baseinfos.forEach((ele) => {
              if (ele.uniscid && !ele.regstateCn.includes("注销")) {
                list.push(ele);
              }
            });
            this.firmList = list;
            console.log("企业列表", this.firmList);
            this.current = 2;
          }
        });
      }
    },
  },
};
</script>
<style scoped lang="scss">
.content {
  height: calc(100vh - 42rem);
  background-color: #fff;
  padding: 0 5rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.content::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}

.title {
  font-size: 10rem;
  font-weight: bold;
  text-align: center;
  margin-bottom: 3rem;
}

.qrcoe-img {
  display: block;
  width: 70rem;
  height: 70rem;
  margin-bottom: 4rem;
}

.tips {
  font-size: 6rem;
  font-weight: bold;
  text-align: center;
}

.goback-btn {
  width: fit-content;
  font-size: 8rem;
  background-color: #0099ff;
  border-radius: 2rem;
  margin: 10rem auto 0;
  font-weight: bold;
  color: #ffffff;
  padding: 3rem 5rem;
}

.yyzz-img {
  display: block;
  margin: auto;
  width: 58%;
  transform: translateY(-10rem);
}

.admin-tips {
  position: fixed;
  bottom: 30rem;
  right: 10rem;
  color: red;
  font-size: 6rem;
  font-weight: bold;
  width: 120rem;
}

.face-idcard-body {
  display: flex;
  background-color: #fff;
  border-radius: 20px;
  padding: 20px;
  align-items: center;

  .idcard-content {
    width: 118rem;
    // background-color: red;
    font-size: 5rem;
    margin-left: 20px;

    .idcard-card-avatar {
      display: flex;
      // justify-content: space-between;

      .user-idcard-avatar {
        width: 42rem;
        height: 50rem;
        margin-left: 40px;
      }

      .idcard-box {
        display: flex;
        margin-bottom: 7.5rem;

        .idcard-title {
          width: 18rem;
          text-align: justify;
          text-align-last: justify;
        }

        .idcard-userinfo {
          width: 35rem;
          border-bottom: 1px solid rgba(0, 0, 0, 0.2);
        }
      }
    }

    .user-info-box {
      display: flex;
      margin-bottom: 7.5rem;

      .user-info-title {
        width: 18rem;
        text-align-last: justify;
      }

      .userinfo-info {
        width: 100rem;
        border-bottom: 1px solid rgba(0, 0, 0, 0.2);
      }
    }
  }
}

.firm-box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  overflow-y: scroll;

  .firm-card {
    height: fit-content;
    padding: 20px;
    border-radius: 10px;
    box-shadow: 0 0 6px rgba(0, 0, 0, 0.4);
    font-size: 6rem;
    margin-left: 20px;
    margin-bottom: 20px;
  }
}

.firm-box::-webkit-scrollbar {
  width: 0px;
  height: 0px;
}
</style>
